import React from 'react'

const Address = () => {
  return (
    <ul>
      <li>
        <img className="svg" src="img/svg/phone.svg" alt="" />
        <a href="Tel:+8801727567755">+880 1727 567755</a>
      </li>
      {/* End li */}

      <li>
        <img className="svg" src="img/svg/mail.svg" alt="" />
        <span>
          <a href="mailto:ahmmedabir9@gmail.com">ahmmedabir9@gmail.com</a>
        </span>
      </li>
      {/* End li */}

      <li>
        <img className="svg" src="img/svg/map.svg" alt="" />
        <span>
          CRP Amtola, Savar
          <br /> Dhaka, Bangladesh
        </span>
      </li>
    </ul>
  )
}

export default Address
